import React from "react";
import { Text } from "basis";
import styled, { css } from "styled-components";
import { BREAKPOINT } from "./theme";

const Wrapper = styled.div`
  ${(props) =>
    props.mobileTextAlign &&
    css`
      p {
        @media screen and (max-width: ${BREAKPOINT.SIZE_MOBILE}) {
          text-align: ${props.mobileTextAlign};
        }
      }
    `}

  ${(props) =>
    props.fullWidth &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.font14 &&
    css`
      p {
        font-size: 14px;
      }
    `}

  ${(props) =>
    props.color &&
    css`
      p {
        color: ${props.color};
      }
    `}

    ${(props) =>
      props.capitalize &&
      css`
        p {
          text-transform: capitalize;
        }
      `}
    ${(props) =>
      props.fontSize &&
      css`
        p {
          font-size: ${props.fontSize};
        }
      `}

      ${(props) =>
        props.fontFamily &&
        css`
          p {
            font-family: ${props.fontFamily}, sans-serif;
          }
        `}
`;

export default ({
  mobileTextAlign,
  fullWidth,
  font14,
  color,
  capitalize,
  children,
  fontSize,
  fontFamily,
  ...restProps
}) => {
  const containerProps = {
    ...restProps,
    mobileTextAlign,
  };

  return (
    <Wrapper
      mobileTextAlign={mobileTextAlign}
      fullWidth={fullWidth}
      font14={font14}
      color={color}
      capitalize={capitalize}
      fontSize={fontSize}
      fontFamily={fontFamily}
    >
      <Text {...containerProps}>{children}</Text>
    </Wrapper>
  );
};
